import request from '@/utils/request'

const leadUrl = '/erp/crm/lead'
const followUrl = '/erp/crm/follow-up'
const publicPoolUrl = '/erp/crm/public-pool'
const poolConfigUrl = '/erp/crm/pool-config'
const reminderUrl = '/erp/crm/reminder'

export function pageCrmLead (params) {
  return request({ url: leadUrl + '/page', method: 'get', params })
}

export function getCrmLead (id) {
  return request({ url: leadUrl + '/detail', method: 'get', params: { id } })
}

export function addCrmLead (data) {
  return request({ url: leadUrl + '/add', method: 'post', data })
}

export function editCrmLead (data) {
  return request({ url: leadUrl + '/edit', method: 'post', data })
}

export function claimCrmLead (id) {
  return request({ url: leadUrl + '/claim', method: 'post', data: { id } })
}

export function assignCrmLead (data) {
  return request({ url: leadUrl + '/assign', method: 'post', data })
}

export function batchClaimCrmLead (ids) {
  return request({ url: leadUrl + '/batch-claim', method: 'post', data: { ids } })
}

export function batchAssignCrmLead (ids, ownerUserId) {
  return request({ url: leadUrl + '/batch-assign', method: 'post', data: { ids, ownerUserId } })
}

export function convertCrmLeadToCustomer (data) {
  return request({ url: leadUrl + '/convert-customer', method: 'post', data })
}

export function importCrmLead (data) {
  return request({
    url: leadUrl + '/import',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function exportCrmLeadImportErrors (data) {
  return request({
    url: leadUrl + '/import-errors',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export function pageCrmFollowUp (params) {
  return request({ url: followUrl + '/page', method: 'get', params })
}

export function getCrmFollowUp (id) {
  return request({ url: followUrl + '/detail', method: 'get', params: { id } })
}

export function listCrmOperationLogs (businessType, businessId) {
  return request({ url: followUrl + '/operation-logs', method: 'get', params: { businessType, businessId } })
}

export function uploadCrmFollowUpAttachment (data) {
  return request({
    url: followUrl + '/attachment/upload',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function addCrmFollowUp (data) {
  return request({ url: followUrl + '/add', method: 'post', data })
}

export function editCrmFollowUp (data) {
  return request({ url: followUrl + '/edit', method: 'post', data })
}

export function revokeCrmFollowUp (id, reason) {
  return request({ url: followUrl + '/revoke', method: 'post', data: { id, reason } })
}

export function pageCrmPublicPool (params) {
  return request({ url: publicPoolUrl + '/page', method: 'get', params })
}

export function exportCrmPublicPool (params) {
  return request({ url: publicPoolUrl + '/export', method: 'get', params })
}

export function enterCrmPublicPool (data) {
  return request({ url: publicPoolUrl + '/enter', method: 'post', data })
}

export function claimCrmPublicPool (id) {
  return request({ url: publicPoolUrl + '/claim', method: 'post', data: { id } })
}

export function assignCrmPublicPool (data) {
  return request({ url: publicPoolUrl + '/assign', method: 'post', data })
}

export function getCrmPublicPool (id) {
  return request({ url: publicPoolUrl + '/detail', method: 'get', params: { id } })
}

export function batchClaimCrmPublicPool (ids) {
  return request({ url: publicPoolUrl + '/batch-claim', method: 'post', data: { ids } })
}

export function getCrmPoolConfig () {
  return request({ url: poolConfigUrl + '/get', method: 'get' })
}

export function updateCrmPoolConfig (data) {
  return request({ url: poolConfigUrl + '/update', method: 'post', data })
}

export function runCrmPoolAuto () {
  return request({ url: poolConfigUrl + '/auto-run', method: 'post' })
}

export function listCrmPoolAutoRuns () {
  return request({ url: poolConfigUrl + '/auto-runs', method: 'get' })
}

export function pageCrmReminder (params) {
  return request({ url: reminderUrl + '/page', method: 'get', params })
}

export function getCrmReminderSummary (limit = 5) {
  return request({ url: reminderUrl + '/summary', method: 'get', params: { limit } })
}
